import { render } from "./ContactPage.vue?vue&type=template&id=a5862e38&scoped=true"
const script = {}

import "./ContactPage.vue?vue&type=style&index=0&id=a5862e38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5862e38"]])

export default __exports__